export default "<div class=\"ion-text-center\">\n  <ion-button href=\"{{el.image_url}}\" target=\"_system\" mode=\"ios\">{{el.text}}</ion-button>\n</div>";